import React from 'react';
import { Box, Skeleton } from '@mui/material';

export const TemplateSkeleton = () => {
  return <Box sx={{ width: '600px', margin: '0 auto' }}>
    <Skeleton variant="rectangular" height={20} width={'100%'} />

    <Box sx={{ display: 'flex', flexDirection: 'row', marginTop: '5px', height: '70px', alignItems: 'center' }}>
      <Skeleton variant="rectangular" height={70} width={165} />
      <Box sx={{ display: 'flex', flexDirection: 'column', margin: '0 0 0 auto', width: '230px' }}>
        <Skeleton variant="rectangular" height={20} width={230} />
        <Skeleton variant="rectangular" height={24} width={150} sx={{ marginTop: '5px', marginLeft: 'auto' }} />
      </Box>
    </Box>

    <Skeleton variant="rectangular" height={4} width={'100%'} sx={{ marginTop: '5px' }} />

    <Box sx={{ marginTop: '50px' }}>
      <Skeleton variant="rounded" height={15} width={'250px'} sx={{ margin: '5px 0 0 40px' }} />
      <Skeleton variant="rounded" height={15} width={'450px'} sx={{ margin: '5px 0 0 40px' }} />
      <Skeleton variant="rounded" height={15} width={'480px'} sx={{ margin: '5px 0 0 40px' }} />
      <Skeleton variant="rounded" height={15} width={'500px'} sx={{ margin: '5px 0 0 40px' }} />
      <Skeleton variant="rounded" height={15} width={'390px'} sx={{ margin: '5px 0 0 40px' }} />
    </Box>

    <Box sx={{ display: 'flex', margin: '50px auto', width: "365px" }}>
      <Skeleton variant="rectangular" height={38} width={'165px'} sx={{ marginRight: '20px' }} />
      <Box sx={{ display: 'flex', flexDirection: 'column', width: '180px' }}>
        <Skeleton variant="rectangular" height={12} width={'100%'} sx={{}} />
        <Skeleton variant="rectangular" height={22} width={'75%'} sx={{ marginTop: '4px' }} />
      </Box>
    </Box>

    <Skeleton variant="rectangular" height={4} width={'100%'} sx={{ marginTop: '5px' }} />

    <Box sx={{ marginTop: '20px', display: 'flex', flexDirection: 'row' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', width: '200px', padding: '0 20px' }}>
        <Skeleton variant="rounded" height={16} width={'100%'} />
        <Skeleton variant="rounded" height={16} width={'90%'} sx={{ marginTop: '4px' }} />
        <Skeleton variant="rounded" height={14} width={'90%'} sx={{ marginTop: '10px' }} />
        <Skeleton variant="rounded" height={14} width={'80%'} sx={{ marginTop: '4px' }} />
        <Skeleton variant="rounded" height={12} width={'70%'} sx={{ marginTop: '10px' }} />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', padding: '0 20px' }}>
        <Skeleton variant="rectangular" height={55} width={'100%'} />
        <Skeleton variant="rectangular" height={55} width={'100%'} sx={{ marginTop: '10px' }} />
        <Skeleton variant="rectangular" height={55} width={'100%'} sx={{ marginTop: '10px' }} />
      </Box>
    </Box>

    <Skeleton variant="rectangular" height={100} width={'100%'} sx={{ marginTop: '20px' }} />
  </Box>
}
